<template>
  <div>
    <jd-form
      class="mb16"
      :formData="searchInfo"
      :form-info="getWishingPoolFormInfo"
      @search="getTimeWishPool"
      ref="funGameRecordRef"
    ></jd-form>
    <div style="margin-bottom: 16px" class="flex-between">
      <jd-button type="break" :disabled="!dataSource.length" @click="addCrowd"
        >按查询结果生成人群</jd-button
      >
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="dataSource"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: total,
        }"
        @handlePage="handleCurrentChangeAll"
      >
        <el-table-column
          prop="chaosPin"
          label="用户pin（加密）"
        ></el-table-column>
        <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
        <el-table-column label="投放渠道" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.sellerLinkName || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="参与时间"></el-table-column>
        <el-table-column prop="poolName" label="点亮许愿池"></el-table-column>
        <el-table-column prop="usedCoin" label="消耗许愿币"></el-table-column>
        <el-table-column label="是否抽奖">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.isDraw == 1
                  ? "是"
                  : scope.row.isDraw == 0
                  ? "否"
                  : "--"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="抽奖时间" prop="drawTime" min-width="120"></el-table-column>
        <el-table-column label="中奖状态" prop="isReceiveDesc" min-width="120">
          <!-- <template slot-scope="scope">
            <div class="flexc-cen-x" v-if="scope.row.isWin == 1">
              <i class="new-green-icon-box"></i>
              <span class="ml2">已中奖</span>
            </div>
            <div class="flexc-cen-x" v-else-if="scope.row.isWin == 0">
              <i class="new-gley-icon-box"></i>
              <span class="ml2">未中奖</span>
            </div>
            <div class="flexc-cen-x" v-else>
              <i class="new-yellow-icon-box"></i>
              <span class="ml2">待开奖</span>
            </div>
          </template> -->
        </el-table-column>
        <el-table-column prop="prizeType" label="奖品类型">
          <template slot-scope="scope">
            <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
            <span v-else-if="scope.row.prizeType == 2"> 京豆 </span>
            <span v-else-if="scope.row.prizeType == 3"> 实物 </span>
            <span v-else-if="scope.row.prizeType == 4"> 店铺积分 </span>
            <span v-else-if="scope.row.prizeType == 5"> E卡 </span>
            <span v-else-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
            <span v-else-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
            <span v-else-if="scope.row.prizeType == 8"> 红包 </span>
            <span v-else-if="scope.row.prizeType == 9"> 谢谢参与 </span>
            <span v-else-if="scope.row.prizeType == 10"> 礼品卡 </span>
            <span v-else-if="scope.row.prizeType == 13">令牌</span>
            <span v-else-if="scope.row.prizeType == 12">专享价</span>
            <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="prizeName" label="奖品名称"> </el-table-column>
      </jd-table>
    </div>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
      :activityType="rowData.activityType"
      :source="6"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      :searchForm="crowCondition"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import crowdDialog from "../crowd-Dialog.vue";
import {
  getTimeWishPoolPage,
  getTimeWishPoolExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  components: {
    crowdDialog,
  },
  props: {
    inputWishingPoolInfo: {
      type: Array,
      default: () => [],
    },
    rowData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      total: 0,
      formList: {
        size: 10,
        current: 1,
      },
      dataSource: [],
      loading: false,
      searchInfo: {
        memberNick: "",
        pin: "",
        sellerLinkId: "",
        joinStartTime: "",
        joinEndTime: "",
        isDraw: "",
        prizeName: "",
        prizeTypes: [],
      }, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: true, // 是否有默认值
      defaultValueText: "参与记录", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      crowCondition: {},
    };
  },
  computed: {
    getWishingPoolFormInfo: {
      get() {
        return this.inputWishingPoolInfo;
      },
      set(val) {
        this.$emit("update:inputWishingPoolInfo", val);
      },
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCurrentChangeAll(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
    getTimeWishPool(params) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.searchInfo.memberNick = params.memberNick ? params.memberNick : "";
      this.searchInfo.pin = params.pin ? params.pin : "";
      this.searchInfo.sellerLinkId = params.sellerLinkId
        ? params.sellerLinkId
        : "";
      this.searchInfo.joinStartTime = params.joinStartTime
        ? params.joinStartTime
        : "";
      this.searchInfo.joinEndTime = params.joinEndTime
        ? params.joinEndTime
        : "";
      this.searchInfo.isDraw = params.isDraw;
      this.searchInfo.prizeName = params.prizeName ? params.prizeName : "";
      this.searchInfo.prizeTypes = params.prizeTypes ? params.prizeTypes : [];
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        };
        this.crowCondition = {
          ...params,
          hdSource: 6,
          activityType: this.rowData.activityType,
        };
        const res = await getTimeWishPoolPage(params);
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        this.total = Number(total);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "参与记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(exportRemark = "") {
      let params = {
        ...this.formList,
        ...this.searchInfo,
        activityId: this.rowData.id,
        exportRemark,
      };
      this.formLoading = true;
      getTimeWishPoolExport(params).then((res) => {
        this.formLoading = false;
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
